<div mat-dialog-title class="title">
    <span class="heading">Manage Jurisdictions</span>
    <button mat-dialog-close class="close-button" mat-icon-button matSuffix>
        <mat-icon class="close-icon-color">cancel</mat-icon>
    </button>
</div>
<div mat-dialog-actions class="action-buttons">
    <button mat-raised-button class="small-create-btn" (click)="onCreateJurisdiction()" color="accent">
        Create
    </button>
</div>
<div mat-dialog-content>
    <div class="table-wrapper">
        <table mat-table [dataSource]="jurisdictionData" class="mat-elevation-z8 full-width-table">

            <ng-container matColumnDef="jurisdictionName" sticky>
                <th mat-header-cell *matHeaderCellDef> Jurisdiction Name </th>
                <td mat-cell *matCellDef="let element"> {{element.jurisdictionName}} </td>
            </ng-container>

            <ng-container matColumnDef="jurisdictionCode" sticky>
                <th mat-header-cell *matHeaderCellDef> Code </th>
                <td mat-cell *matCellDef="let element"> {{element.jurisdictionCode}} </td>
            </ng-container>

            <ng-container matColumnDef="jurisdictionOrgKey" sticky>
                <th mat-header-cell *matHeaderCellDef> Org Key </th>
                <td mat-cell *matCellDef="let element"> {{element.jurisdictionOrgKey}} </td>
            </ng-container>

            <ng-container matColumnDef="dateFormat" sticky>
                <th mat-header-cell *matHeaderCellDef> Date Format </th>
                <td mat-cell *matCellDef="let element">
                    {{ element.dateFormat || '-' }}
                </td>
            </ng-container>

            <ng-container matColumnDef="action" sticky>
                <th mat-header-cell *matHeaderCellDef> Action </th>
                <td mat-cell *matCellDef="let element">
                    <button mat-icon-button color="accent" (click)="onEditJurisdiction(element)">
                        <mat-icon>edit</mat-icon>
                    </button>
                    <button mat-icon-button color="warn" (click)="onDeleteJurisdiction(element)">
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
</div>
